import { useQuery } from '@apollo/client';
import React from 'react';
import { COMMENT_QUERY } from '../../../helpers/graphql/comments';
import CommentItem from './CommentItem';

const PostComments = props => {
  const { rootId } = props;

  const { data } = useQuery(COMMENT_QUERY, {
    variables: { rootId },
    ssr: false,
  });

  return (
    <>
      {data && data.comments && data.comments.length > 0 ? (
        data.comments.map(comment => {
          if (
            (props.parentId && comment.parentId !== props.parentId) ||
            (!props.parentId && comment.depth !== 1)
          )
            return <></>;
          return (
            <CommentItem
              key={`${comment.author.username}/${comment.permlink}`}
              comment={comment}
              comments={data.comments}
            />
          );
        })
      ) : (
        <></>
      )}
    </>
  );
};

export default PostComments;
